import React from "react";
import Description from "./Description";
import Title from "./Title";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import LocalOffer from "@material-ui/icons/LocalOffer";
import ShoppingCart from "@material-ui/icons/ShoppingCart";

const YourBenefits = () => {
  return (
    <section className="benefits-section">
      <div className="benefits-container">
        <Title
          textAlign="center"
          textColor="black"
          fontSize="28px"
          fontWeight="600"
          content="Exclusively on DressTwin"
        />
        <div className="benefits-box">
          <div className="benefits-item">
            <PeopleAltOutlinedIcon />
            <div className="benefits-content">
              <Title
                textAlign="left"
                textColor="black"
                fontSize="16px"
                fontWeight="600"
                content="By Invitation Only"
              />
              <Description
                textColor="black"
                textAlign="left"
                content="Join an exclusive community of fashion aficionados. Access is invite-only, ensuring that every member shares our passion for the perfect fit and style."
              />
            </div>
          </div>
          <div className="benefits-item">
            <LocalOffer />
            <div className="benefits-content">
              <Title
                textAlign="left"
                textColor="black"
                fontSize="16px"
                fontWeight="600"
                content="Unbeatable Fashion Deals"
              />
              <Description
                textColor="black"
                textAlign="left"
                content="Enjoy top-condition, pre-loved luxury fashion at prices you won’t find anywhere else. Every deal is as exceptional as the quality of our curated selection."
              />
            </div>
          </div>
          <div className="benefits-item">
            <ShoppingCart />
            <div className="benefits-content">
              <Title
                textAlign="left"
                textColor="black"
                fontSize="16px"
                fontWeight="600"
                content="Effortless Buying & Selling"
              />
              <Description
                textColor="black"
                textAlign="left"
                content="Sell your luxury items without the hassle. List, receive genuine offers, and transact in a stress-free environment—no lowballing, just real value."
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YourBenefits;
